import { useMutation, useQuery } from '@apollo/client'
import React, { useContext, useEffect, useRef, useState } from 'react'
import {
  DELETE_RATING,
  GET_ALL_RATINGS_BY_USER,
} from '../../../../../../graphql/Catalog/UsersRating/usersRating'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import Box from '../../../../../Global/Box'
import LayoutTable from '../../../../../Global/LayoutTable'
import ModalContent from '../../../../../Global/ModalContent'
import moment from 'moment'
import DetailsRatings from './DetailsRatings'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'
import { AuthContext } from '../../../../../../Auth/AuthContext'
import { objNameRoles } from '../../../../../../const/constRoles'

const Ratings = ({
  userId,
  handleViewDetailsAux = () => {},
  handleEditAux = () => {},
  setRefetchs = false,
}) => {
  const { user } = useContext(AuthContext)
  const isAdminOrMasterIsCoordinator =
    user.is_coordinator ||
    [
      objNameRoles.admin,
      objNameRoles.master,
      objNameRoles.alcalde_tlajomulco,
    ].includes(user.role)

  const { showLoading, hideLoading } = useLoading()

  const modalRefAux = useRef(null)
  const [dataTable, setDataTable] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [closeModal, setCloseModal] = useState(false)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: '',
    limit: 10,
    offset: 0,
    onlySearchById: false,
  })
  const [modal, setModal] = useState({
    title: '',
    size: 'large',
    modalId: null,
    content: null,
  })
  const { loading, error, data, refetch } = useQuery(GET_ALL_RATINGS_BY_USER, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      onlySearchById: pagePagination.onlySearchById,
      userId: userId ? parseInt(userId) : null,
    },
    fetchPolicy: 'no-cache',
  })

  const [deleteRating] = useMutation(DELETE_RATING)

  useEffect(() => {
    if (pagePagination.searchQuery === '') {
      setPagePagination((prev) => ({
        ...prev,
        onlySearchById: false,
      }))
    }
  }, [pagePagination.searchQuery])

  useEffect(() => {
    const storedRatingId = localStorage.getItem('ratingId')
    const parsedRatingId = JSON.parse(storedRatingId)
    if (storedRatingId) {
      setModal({
        title: 'Detalles de calificación',
        content: (
          <DetailsRatings
            ratingId={parsedRatingId}
            setCloseModal={setCloseModal}
          />
        ),
        modalId: 'modal-rating-details',
        size: 'large',
      })
      setPagePagination((prev) => ({
        ...prev,
        searchQuery: JSON.parse(storedRatingId),
        onlySearchById: true,
      }))
      localStorage.removeItem('ratingId')
    }
  }, [])

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw new Error(error.message)

      const dataRows = data.getAllRatingsByUserId.rows.map((item) => {
        return {
          id: item.id,
          Calificador: `${item.userRated.name} ${
            item.userRated.first_name || ''
          } ${item.userRated.last_name || ''}`,
          fecha: moment(item.createdAt).format('DD/MM/YYYY'),
          Tipo: item.feedback_type_label,
          comentario:
            item.comment.length > 20
              ? `${item.comment.slice(0, 20)}...`
              : item.comment,
          row__omit: item,
        }
      })

      setDataTable(dataRows)
      setTotalCount(data.getAllRatingsByUserId.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error])

  useEffect(() => {
    if (modal.modalId) {
      document.getElementById(`spanModal${modal.modalId}`).click()
    }
  }, [modal])
  useEffect(() => {
    if (closeModal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
      setModal({
        title: '',
        content: null,
        modalId: null,
        size: 'large',
      })
      setCloseModal(false)
    }
  }, [closeModal])

  useEffect(() => {
    if (setRefetchs) {
      setRefetchs([refetch])
    }
  }, [setRefetchs])

  const handleViewDetails = (row) => {
    setModal({
      title: 'Detalles de calificación',
      content: (
        <DetailsRatings ratingId={row.id} setCloseModal={setCloseModal} />
      ),
      modalId: 'modal-rating-details',
      size: 'large',
    })
  }

  const handleDeleteButton = async (row) => {
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        message: `¿Estás seguro de eliminar la calificación?`,
        icon: 'warning',
      })

      if (!response.isConfirmed) return

      showLoading()

      const { data: deleteResponse } = await deleteRating({
        variables: {
          deleteUserRatingId: +row,
        },
        fetchPolicy: 'no-cache',
      })

      if (deleteResponse.deleteUserRating) {
        await refetch()
        return toastSweetAlert({
          mode: 'ok',
          message: 'Calificación eliminada correctamente',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <LayoutTable
        withCard={userId ? false : true}
        hideId
        data={dataTable}
        hideAddNew
        title="Buzón ciudadano"
        totalCount={totalCount}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        actionBtnDetails={userId ? handleViewDetailsAux : handleViewDetails}
        actionBtnEdit={userId ? handleEditAux : null}
        actionBtnErase={handleDeleteButton}
        detailsText={<i className="fas fa-eye" />}
        // hideBtnDelete
        hideBtnEdit={!isAdminOrMasterIsCoordinator}
        FilterBarPlaceholder="Buscar por comentario o calificador"
        cols_search_div="col-12"
        cols_search="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
        hideBtnDelete={!isAdminOrMasterIsCoordinator}
      />

      <span
        id={`spanModal${modal.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modal.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={modalRefAux}
      />

      <ModalContent
        idModal={modal.modalId}
        title={modal.title}
        size={modal.size}
        onClose={() => {
          setModal({
            title: '',
            content: null,
            modalId: null,
            size: 'large',
          })
        }}
        content={modal.content}
      />
    </>
  )
}

export default Ratings
